const footerColumns = [
  {
    title: "站内导航",
    links: [
      { label: "内容方向", id: "offerings" },
      { label: "影片库", id: "library" },
      { label: "九十年代年表", id: "nineties" },
    ],
  },
  {
    title: "观看相关",
    links: [
      { label: "怀旧剧场排片", id: "theater" },
      { label: "观影指南", id: "watch" },
      { label: "名词小词典", id: "glossary" },
    ],
  },
  {
    title: "了解本站",
    links: [
      { label: "题材分布", id: "stats" },
      { label: "影迷问答", id: "faq" },
      { label: "返回顶部", id: "top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 px-4 md:px-8 pt-14 md:pt-16 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                九七电影院
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100 max-w-md">
              九七电影院面向怀旧老片片库需求，整理老电影、怀旧片、经典港片与九十年代电影，
              并补充老片在线与怀旧剧场两个方向，方便你按年代与类型逐步查找。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <span className="px-3 py-1.5 rounded-full bg-primary-800 text-primary-100 text-xs font-label">
                老电影
              </span>
              <span className="px-3 py-1.5 rounded-full bg-primary-800 text-primary-100 text-xs font-label">
                经典港片
              </span>
              <span className="px-3 py-1.5 rounded-full bg-primary-800 text-primary-100 text-xs font-label">
                怀旧剧场
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-accent-200">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-primary-100 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 h-px w-full bg-primary-800" />

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-200 text-center sm:text-left">
            本站内容为怀旧老片的整理与导览，影片信息为常见公开资料，如需精确版本与发行细节请另行核实。
          </p>
          <p className="text-xs text-primary-200">九七电影院 · 怀旧光影整理</p>
        </div>
      </div>
    </footer>
  );
}